export const linkButtonTitles = {
  en: 'See more',
  de: 'Mehr sehen',
  ru: 'Смотреть все',
  tr: 'Daha fazla gör',
};

export const readMoreDict = {
  en: {
    caseStudies: 'Case studies',
  },
  ru: {
    caseStudies: 'История клиента',
  },
  de: {
    caseStudies: 'Fallstudien',
  },
  tr: {
    caseStudies: 'Vaka çalışmaları',
  },
};
